import { render, staticRenderFns } from "./HorizontalNavMenuItemsLogo.vue?vue&type=template&id=5c5219a8&"
import script from "./HorizontalNavMenuItemsLogo.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuItemsLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports